/* Package JSON Import will be here */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
    withRouter
} from 'react-router-dom';
/* Package JSON Import will be here */

/* Project Import will be here */
import TimeCardDailyDetailsComponent from './timeCardDailyDetails.Component';
import { ApiUrls } from '../../../services/api';
import Api from '../../../services/api/serviceCall';
import * as moment from 'moment';
import { Constants } from '../../../config/appConstants';
import { format } from 'date-fns';


/* Const,Let & Var will be here */
/* Const,Let & Var will be here */

class TimeCardDailyDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isModalVisible: true,
            selectedDate: this.props.isCheckedArchive ? this.props.maximumDate : new Date(),
            searchDailyDetailText: "",
            pagination: {
                activePage: 1,
                totalCount: 0,
                skip: Constants.DEFAULT_SKIP,
                take: Constants.DEFAULT_TAKE
            },
            calendarMaxDate: '',
            dailyDetailsInspection:[],
            dailyDetailsEquipment:[],
            activeIndex:0,
            minimumDate: this.props.minimumDate ? this.props.minimumDate : null,
            maximumDate: this.props.maximumDate ? this.props.maximumDate : null
        };
    }

    componentWillMount() {
        this.setState({ isModalVisible: true }, () => {
            if(this.props.isCheckedArchive){
                this.setState({ selectedDate: this.props.maximumDate })
            }
            this.getDailyDetails();
            this.currentWeekLastDate();
        });
    }
        

    findNextObjectWithDescription(list, start, prop, projectNumber) {
        for (let i = start + 1; i < list.length; i++) {
            let obj = list[i];
            if (obj[prop] && obj.projectNumber === projectNumber) {
                return obj;
            }
        }
        return null;
    }

    getDailyDetails(date = null) {
        let { pagination,activeIndex, dailyDetailsInspection, dailyDetailsEquipment,searchDailyDetailText, minimumDate, maximumDate } = this.state;
        var datePicked = date != null ? new Date(date) : new Date(this.state.selectedDate);
        var startTime = new Date(datePicked.setHours(0, 0, 0));
        var startDate = new Date(startTime.setMinutes(startTime.getTimezoneOffset()));
        var tomorrow = date == null ? new Date(this.state.selectedDate) : new Date(date);
        var endTime = tomorrow.setDate(tomorrow.getDate() + 1);
        var endDate = new Date(endTime);
        endDate.setHours(0, 0, 0);
        var dateEndTime = new Date(endDate.setMinutes(endDate.getTimezoneOffset()));
        var selectDate = moment(startDate).format('DD-MM-YYYY');
        var selectedDate = moment(dateEndTime).format('DD-MM-YYYY');
        var timeZone = startDate.toString();
        var selectTimeZone = timeZone.slice(16, 24);
        var fromDate = `${selectDate} ${selectTimeZone}`;
        var toDate = `${selectedDate} ${selectTimeZone}`;

        const seletedTab = activeIndex === 0 ? Constants.DAILY_DETAILS_INSPECTION : Constants.DAILY_DETAILS_EQUIPMENT;
        let searchArray = [{
            FieldName: seletedTab,
            Value: ''
        },{
            FieldName: Constants.USER_ID,
            value: this.props.user.userId.toString()
        }];
        
        if (searchDailyDetailText) {
            searchArray.push({
                FieldName: Constants.DAILY_DETAILS_SEARCH,
                Value: searchDailyDetailText
            });
        };
        
        let requestData = {
            SearchText: searchArray,
            Skip: pagination.skip,
            Take: pagination.take
        }

        let url = `${ApiUrls.Routes.DALYDET_C}${ApiUrls.Routes.GT_DALY_DTL_LT_M}?fromDate=${fromDate}&&toDate=${toDate}&&isCheckedArchive=${this.props.isCheckedArchive}`;
        Api.Post(url, requestData, this).then(responseData => {
            if (responseData.success) {
                pagination.totalCount = Math.ceil(responseData.totalCount / Constants.DEFAULT_TAKE);
                if (activeIndex === 0) {                    
                     dailyDetailsInspection = responseData.data;
                }
                else
                {
                    dailyDetailsEquipment = responseData.data;
                }
                this.setState({                    
                    dailyDetailsInspection,
                    dailyDetailsEquipment,
                    pagination
                });
            }
        });
    }

    onTabChange =(e,data)=> {
        this.setState({
            activeIndex: data.activeIndex
        },
        ()=> {
            this.getDailyDetails();
         }
        );
    }
    closeModal() {
        this.setState({
            isModalVisible: false
        });
        this.props.closeDailyDetails(true)
    }

    openModal() {
        this.setState({
            isModalVisible: true,
        });
    }

    handleDateChange(date) {
        if ((new Date(date) !== "Invalid Date") && !isNaN(new Date(date))) {
            this.setState({
                selectedDate: date
            }, () => {
                this.getDailyDetails(date);
            });
        }
    }

    onDailyDetailsSearch = event => {
        this.setState({ searchDailyDetailText: event.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 } }, () => {
            this.getDailyDetails();
        });
    }

    paginationChange = (e, { activePage }) => {
        let { pagination } = this.state;
        pagination.skip = ((activePage - 1) * Constants.DEFAULT_TAKE) + 1;
        pagination.take = ((activePage - 1) * Constants.DEFAULT_TAKE) + Constants.DEFAULT_TAKE;
        pagination.activePage = activePage;
        this.setState({
            pagination
        }, () => {
            this.getDailyDetails();
        });
    }

    currentWeekLastDate() {
        let { calendarMaxDate } = this.state;
        let lastday =  new Date().getDate() - (new Date().getDay() - 1) + 6;
        let lastDayOfTheWeek = new Date(new Date().setDate(lastday));
        calendarMaxDate = format(lastDayOfTheWeek, 'MM/dd/yyyy')
        if(this.props.isCheckedArchive){
            calendarMaxDate = null;
        }
        this.setState({ calendarMaxDate });
    }

    render() {
        const { dailyDetailsInspection, dailyDetailsEquipment, isModalVisible, selectedDate, pagination, calendarMaxDate, minimumDate, maximumDate } = this.state;
        return (
            <Fragment>
                <TimeCardDailyDetailsComponent
                    {...{
                        timeCardDailyDetails: {                    
                            dailyDetailsInspection,
                            dailyDetailsEquipment,
                            isModalVisible,
                            selectedDate,
                            pagination,
                            calendarMaxDate,
                            minimumDate,
                            maximumDate
                        }
                    }}
                    closeModal={this.closeModal.bind(this)}
                    openModal={this.openModal.bind(this)}
                    handleDateChange={this.handleDateChange.bind(this)}
                    onDailyDetailsSearch={this.onDailyDetailsSearch.bind(this)}
                    paginationChange={this.paginationChange.bind(this)}
                    onTabChange={this.onTabChange.bind(this)}
                />
            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.loginReducer.user
    };
}

export default withRouter(connect(mapStateToProps)(TimeCardDailyDetails));

TimeCardDailyDetails.displayName = 'TimeCardDailyDetails';